export function setQuerys(state, payload) {
  state.query = payload;
}